<!-- MFITTのシートマップ画面で、車椅子・介護席を選択している場合に、確認を出す -->
<template>
  <ItemDialog ref="confirmSelectedSpecialCar" imageType="alert">
    <template v-slot:content-area>
      <p class="text-center">
        {{ selectedCar.exclusive_car_name }}を選択しています
        <br/>{{ message }}
      </p>
    </template>
    <template v-slot:button-area>
      <ItemButton label="OK" actionType="btn-primary" @clicked="ok()" />
      <ItemButton
        label="キャンセル"
        actionType="btn-cancel"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { onMounted, ref } from "vue";
import API from "@/API";

export default {
  name: "DialogConfirmSelectedSpecialCar",
  props: {
    clickOk: {
      type: Function,
      required: true,
    },
    selectedCar: {
      type: Object,
      required: true,
    },
    specialDesignationId: {
      type: String,
      required: true,
    }
  },
  setup(props) {
    const confirmSelectedSpecialCar = ref(null);
    const message = ref('')
    
    const ok = () => {
      props.clickOk();
      confirmSelectedSpecialCar.value.close();
    };

    const openDialog = async () => {
      try {
        const result = await API.getSpecialCarContent(props.specialDesignationId);
        message.value = result || ""
      } catch (error) {
        console.log("error :>> ", error);
      }
      confirmSelectedSpecialCar.value.open();
    };

    const closeDialog = () => {
      confirmSelectedSpecialCar.value.close();
    };

    return {
      confirmSelectedSpecialCar,
      message,
      ok,
      openDialog,
      closeDialog,
    };
  },
};
</script>
<style scoped lang="scss">
.text-center {
  text-align: center;
}
</style>
